import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { HiChevronDown } from 'react-icons/hi';
import { useAccordionContext } from './AccordionPanelContext';
export const AccordionTitle = ({ children, className, arrowIcon: ArrowIcon = HiChevronDown, ...props }) => {
    const { flush, isOpen, setIsOpen } = useAccordionContext();
    const onClick = () => setIsOpen(!isOpen);
    return (_jsxs("button", { "data-testid": "accordion-title-element", ...props, type: "button", className: classNames('flex w-full items-center justify-between py-5 text-left font-medium text-gray-500 dark:text-gray-400', {
            'hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 dark:hover:bg-gray-800 dark:focus:ring-gray-800': !flush,
            'text-gray-900 dark:text-white': isOpen,
            'bg-gray-100 dark:bg-gray-800': isOpen && !flush,
        }, className), onClick: onClick, children: [_jsx("h2", { children: children }), _jsx(ArrowIcon, { className: classNames('h-6 w-6 shrink-0', { 'rotate-180': isOpen }) })] }));
};
